export const userTypes = {
	PRICE_AGREEMENT: 0,
	FREE_BIRD: 1
};

export const userStates = {

};

export const validationTypes = {
	REQUIRED: 1,
	MALFORMATTED: 3,
	ALREADY_IN_USE: 5,
	USER_NAME_EXISTS: 7,
	INVALID: 11
};

export const globalSearchEvents = {
	SEARCH: 'search',
	AUTO_SUGGEST_SEARCH: 'autosuggestsearch',
	RESET: 'reset',
	UP: 'up',
	DOWN: 'down',
};

export const productSearchEvents = {
	SEARCH: 'search',
	SHORT_CODE_SEARCH: 'shortcodesearch',
	AUTO_SUGGEST_SEARCH: 'autosuggestsearch',
	SUGGESTION_CLICKED: 'suggestionclicked',
	RESET: 'reset',
	UP: 'up',
	DOWN: 'down',
};

export const enrollmentEvents = {
	FACILITY_CHANGED: 'facilitychanged',
};

export const enrollmentStatuses = {
	DRAFT: 'draft',
	PENDING_SIGNATURE: 'pendingSignature',
	SUBMITTED: 'submitted',
}

export const enrollmentStatusesValues = {
	DRAFT: 'Draft, EMRDraft',
	PENDING_SIGNATURE: 'PendingSignature',
	SUBMITTED: 'Submitted, SubmittedUnsigned',
}

export const screenSizes = {
	DESKTOP: 1024,
};

export const cookieNames = {
	VISITOR_ID: 'VisitorID',
	FORM_SUBMIT_STATUS: 'epiform-submit-status',
	ENROLLMENT_PREVIOUSLY_LOGGED_IN: 'enrollment-prev-logged-in',
	ENROLLMENT_LOGGED_IN: 'enrollment-logged-in',
	CONSUMER_SIGNUP_SUCCESS_STATUS: 'consumer-signup-success',
	CONSUMER_SIGNUP_ERROR_STATUS: 'consumer-signup-error',
	CONSUMER_LOGGED_IN: 'consumer-logged-in',
	CONSUMER_RESET_PASSWORD: 'consumer-reset-password',
	HCP_SIGNUP_JOB_FACILITY: 'hcp-signup-job-facility',
	TRACKING_LIST_NAMES_INITIALIZED: 'tracking-list-names-initialized',
	QUICK_SAMPLE_INITIALIZED: 'quick-sample-initialized'
}

export const addToBasketActions = {
	SAMPLE: 'sample',
	BUY: 'buy',
	REIMBURSEMENT: 'reimbursement',
	KIT_SAMPLE: 'kit'
}

export const addToBasketSample = [ addToBasketActions.SAMPLE, addToBasketActions.KIT ];

export const impressionListSources = {
	UNKNOWN: 'Unknown',
	PRODUCT_PAGE: 'ProductPage',
	PRODUCT_FINDER: 'ProductFinder',
	ONEBLOCK_PRODUCT_SAMPLER: 'OneblockProductSampler',
	QUICK_SAMPLE: 'QuickSample',
	PRODUCT_BROWSING: 'ProductBrowsing',
	SEARCH_BAR_PRODUCT_BROWSING: 'SearchBarProductBrowsing',
	MY_PRODUCTS: 'MyProducts',
	REORDER_MY_ACCOUNT_PRODUCT_LIST: 'reorder_myaccount_product_list',
	REORDER_REGULAR_PRODUCT_LIST: 'reorder_regular_product_list',
	REORDER_SOMETIMES_PRODUCT_LIST: 'reorder_sometimes_product_list',
	RELATED_PRODUCT: 'RelatedProducts',
	QUOTE: 'Quote',
	NON_DISPOSABLE_BASKET_SECTION: "NonDisposableBasketSection",
}

export const trackingOrderTypes = {
	NEW_ORDER: 'New Order',
	REORDER: 'Reorder',
}

// Event names used in ga4 for EEC tracking
export const trackingEventNames = {
	VIEW_ITEM: 'view_item',
	VIEW_ITEM_LIST: 'view_item_list',
	SELECT_ITEM: 'select_item',
	VIEW_CART: 'view_cart',
	ADD_TO_CART: 'add_to_cart',
	REMOVE_FROM_CART: 'remove_from_cart',
	BEGIN_CHECKOUT: 'begin_checkout',
	ADD_PAYMENT_INFO: 'add_payment_info',
	ADD_SHIPPING_INFO: 'add_shipping_info',
	PURCHASE: 'purchase',
	MARKETING_CONSENT: 'marketing_consent',
	SAMPLE_CONSENT: 'sample_consent',
	ORDER_CONSENT: 'order_consent',
	ORDER_SUMMARY: 'order_summary',
	GATED_CONTENT: 'gated_content',
	GATED_CONTENT_CHOICE: 'gated_content_choice',
	HCP_SIGNUP_BEGIN: 'hcp_signup_begin',
	HCP_SIGNUP_STEP: 'hcp_signup_step',
	HCP_SIGNUP_COMPLETED: 'hcp_signup_completed',
	NDIS_FUNDING: "ndis_funding",
	CHECKMARK_INTERACTION: 'checkmark_interaction',
	PROFILE_COMPLETED: 'profile_completed',
	FORM_SUBMISSION: 'form_submission',
	ORDER_CHANGES: 'order_changes',
	CONTENT_ENGAGEMENT: 'content_engagement',
	DUAL_CHECKOUT_CHOICE: 'dual_checkout_choice',
	LOGIN: 'login',
	LOGIN_START: 'login_start',
	SIGN_UP_START: 'sign_up_start',
	SIGN_UP: 'sign_up',
	ADDRESS_CHANGE: 'address_change',
	PRESCRIPTION_INFORMATION: 'prescription_information',
	SUBMIT_CUTTING_TEMPLATE: 'submit_cutting_template',
	COMPLEMENTARY_PRODUCTS: 'complementary_products',
	REIMBURSEMENT: 'reimbursement',
	DELETE_ACCOUNT: 'delete_account',
	PAYMENT_METHOD: 'payment_method',
	ANIMATION: 'animation',
	CTA_BUTTON: 'cta_button',
	BOOKMARK: 'bookmark',
	NOTIFICATION_MESSAGE: 'notification_message',
	BARCODE_SCANNER_USED: 'barcode_scanner_used',
	BARCODE_SCANNER_STARTED: 'barcode_scanner_started',
	SF_DEDUBLICATION_START: "sf_dedublication_start",
	SF_DEDUBLICATION_COMPLETED: "sf_dedublication_completed",
	SIGNUP_CONSENT: 'signup_consent',
	ACTIVE_PRESCRIPTION: "active_prescription",
	MY_ACCOUNT: "my_account",
};

export const notificationMessageEvents = {
	RECOMMENDED_PRODUCTS: 'recommended_products',
	US_TAX_MESSAGE: 'us_tax_message'
}

export const trackingDimensionConstants = {
	NO_DATA: "No Data",
	SAMPLING: "Sampling",
	BUYING: "Buying",
	HYBRID: "Hybrid",
	NEW: "New",
	RETURNING: "Returning",
	SAMPLE: "Sample",
	ORDER: "Order"
};

export const sessionStorageKeys = {
	NON_REGULAR_PRODUCTS_KEY: 'nrp',
}

export const sampleAndPurchaseStates = {
	IS_READ_ONLY: 0,
	IS_SAMPLE_ONLY: 1,
	IS_PURCHASE_ONLY: 2,
	IS_SAMPLE_AND_PURCHASE: 3,
	IS_REIMBURSABLE: 4,
	IS_SAMPLE_AND_REIMBURSABLE: 5,
};

export const kitTypes = {
	HEYLO_STARTER: 'Heylo Starter Kit'
};

export const itemListIdAndName = {
	PRODUCT_LIST: {
		item_list_id: "product_browsing",
		item_list_name: "product_browsing"
	},
	MY_ACCOUNT: {
		item_list_id: "my_account",
		item_list_name: "my_account"
	},
	PRODUCT_PAGE: {
		item_list_id: "my_product",
		item_list_name: "my_product"
	},
	SOMETIMES_PRODUCT: {
		item_list_id: "basket_sometimes_products",
		item_list_name: "basket_sometimes_products"
	},
	AUTO_SUGGEST_SEARCH: {
		item_list_id: "auto_suggest_search",
		item_list_name: "auto_suggest_search"
	},
	MINI_SHOP: {
		item_list_id: "mini_shop",
		item_list_name: "mini_shop"
	},
	COMPLEMENTARY_PRODUCTS: {
		item_list_id: 'complementary_products',
		item_list_name: 'complementary_products',
	},
	CARD_SLIDER_BLOCK: {
		item_list_id: 'card_slider_block',
		item_list_name: 'card_slider_block',
	},
	RELATED_PRODUCTS: {
		item_list_id: 'related_products',
		item_list_name: 'related_products',
	},
	GLOBAL_SEARCH: {
		item_list_id: "global_search",
		item_list_name: "global_search",
	},
	RECOMMENDED_PRODUCTS: {
		item_list_id: "recommended_products",
		item_list_name: "recommended_products",
	},
	SHORTLISTED_PRODUCTS: {
		item_list_id: "shortlisted_products",
		item_list_name: "shortlisted_products",
	},
};

export const facetGroupNames = {
	MANUFACTURER_FACET: 'Manufacturer',
	PRODUCT_PRIMARY_CATEGORY_FACET: 'ProductPrimaryCategory'
}

export const addressTypes = {
	SHIPPING_ADDRESS: 'shippingAddress',
	MAILING_ADDRESS: 'mailingAddress',
	OTHER_ADDRESS: 'otherAddress'
};

export const ignoreOnIsNewAddress = ['consentChoice', 'sensitiveDataCondition', 'termsAndCondition'];

export const themeColorsMap = {
	'h-bg0': '--ds-color-bg-body',
	'h-bg1': '--ds-color-bg-brand-subtle',
	'h-bg2': '--ds-color-bg-body-alt',
	'h-bg3': '--ds-color-bg-accent',
};

export const B_IN_MB = 1048576; // in binary

export const onboardingProductState = {
	UNSELECTED_PLP: 'onboardingPLP'
}

export const queryParams = {
	PRESCRIPTION_UNLOCKED_REDIRECT: 'PrescriptionUnlockedRedirect',
	ONBOARDING_REDIRECT_BACK_URL: 'RedirectBack',
}

export const hashParams = {
	ONBOARDING_STEP: 'onboardingStep',
}

/**
 * @description has the same mapping as the ConsumerOnboardingStepType from
 * 'Features\ConsumerAccount\Enums\ConsumerOnboardingStepType.cs'
 *
 * BE can set the initial step of the onboarding process, thus these mappings
 * must be in compliance
 */
export const ONBOARDING_STEP = Object.freeze({
	start: 1,
	addProduct: 2,
	productSearch: 3,
	productScan: 4,
	productList: 5,
	productDetails: 6,
});

export const DEFAULT_PRODUCT_IMAGE_PATH = '/dist/shared/images/default-product-image.svg';

export const GTM_TRACKING_TRIGGER_NAVIGATION_DELAY_MS = 200;
